export enum LoaderFileKeys {
    // JSON
    masterConfig_json = "masterConfig_json",

    // 
    sfx = "sfx",
    sfx_json = "sfx_json",
    // 
    ui = "ui",
    lobby = "lobby",
    avatars = "avatars",
    cardsBacks = "cardsBacks",
    cardsDeck = "cardsDeck",
    bg = "bg",
    nineslice = "nineslice",
    winloss = "winloss",
    loading = "loading",
    themes = "themes",
}